import React from "react";
import "./phi.css";
import { Link } from "react-router-dom";

function PhiTraining() {
  return (
    <div className="phi-training-page">

      {/* Banner Section */}
      <section className="phi-banner-section">
        <img src="/trainingsbanner.png" alt="PHI Banner" className="phi-banner-img" />
        <div className="phi-banner-overlay">
          <h1>PHI Training Program</h1>
          <p>Join our PHI training program to enhance skills and knowledge in eye health awareness.</p>
        </div>
      </section>

      {/* Description Section */}
      <section className="phi-description-section">
        <div className="phi-text">
          <h2>About PHI Training Program</h2>
          <p>
            The PHI Training program focuses on enhancing the skills of Public Health Inspectors in conducting eye health assessments
            and promoting awareness within communities. Participants gain practical knowledge and hands-on experience to improve
            eye health outreach and preventive care initiatives across the region.
          </p>
        </div>
        <div className="phi-image">
          <img src="/phi-mid-banner.png" alt="PHI Training" />
        </div>
      </section>


<section className="phi-held-programme-wrapper">
  <div className="phi-held-programme-header">
    <h1>Recent PHI Training Sessions</h1>
    <p>
      Explore our latest Public Health Inspector training sessions, empowering communities
      with knowledge and skills for better eye health awareness.
    </p>
  </div>

  <div className="phi-held-programme-gallery">
    <img src="/aware1.jpg" alt="PHI Held Programme 1" />
    <img src="/aware2.jpg" alt="PHI Held Programme 2" />
    <img src="/aware3.jpg" alt="PHI Held Programme 3" />
    <img src="/aware4.jpg" alt="PHI Held Programme 4" />
    <img src="/aware5.jpg" alt="PHI Held Programme 5" />
    <img src="/aware6.jpg" alt="PHI Held Programme 6" />
    <img src="/aware7.jpg" alt="PHI Held Programme 7" />
    <img src="/aware8.jpg" alt="PHI Held Programme 8" />
    <img src="/aware9.jpg" alt="PHI Held Programme 9" />
    <img src="/aware10.jpg" alt="PHI Held Programme 10" />
    <img src="/aware11.jpg" alt="PHI Held Programme 11" />
    <img src="/aware12.jpg" alt="PHI Held Programme 12" />
    <img src="/aware13.jpg" alt="PHI Held Programme 13" />
    <img src="/aware14.jpg" alt="PHI Held Programme 14" />
    <img src="/aware15.jpg" alt="PHI Held Programme 15" />
    <img src="/aware16.jpg" alt="PHI Held Programme 16" />
    <img src="/aware17.jpg" alt="PHI Held Programme 17" />
    <img src="/aware18.jpg" alt="PHI Held Programme 18" />
  </div>
</section>

<section className="phi-footer-section">
  <div className="phi-footer-content">
    <h2>Be Part of the Change</h2>
    <p>Join us in making a lasting difference in eye health awareness across communities.</p>
    <Link to="/contactus">
      <button className="phi-footer-button">Get Involved</button>
    </Link>
  </div>
</section>



</div>
  );
}

export default PhiTraining;
